<template>
  <div class="swiper-contain">
    <img v-if="!isMobile" class="v-l" @click="slide('slidePrev')" :src="`${$cdn}/assets/images/left${progress===0?'_disable':''}.png`" alt="">
    <swiper
      ref="listSwiper"
      class="swiper-wrapper swiper-wrapper-n"
      :options="swiperOption"
    >
      <swiper-slide
        class="swiper-slide"
        v-for="(item, index) in items"
        :key="index"
      >
          <div class="sw-card" :class="{swActive:activeIdx===item.link}" @click='goto(item)'>
            <img class="main-img" :src="item.image" />
            <p>{{ item.text }}</p>
          </div>
      </swiper-slide>
    </swiper>
    <img v-if="!isMobile" class="v-r" @click="slide('slideNext')" :src="`${$cdn}/assets/images/right${progress===1?'_disable':''}.png`" alt="">
  </div>
</template>
<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import {data} from "./data";
import browser from '@/utils/browser'

export default {
  computed: {
    swiper() {
      return this.$refs.listSwiper.$swiper;
    },
    swiperOption() {
      // let that = this
      let tmp = !this.isMobile?{
        slidesPerView: 5,
        spaceBetween: 40,
        centeredSlides: true,
        centeredSlidesBounds:true,
        centerInsufficientSlides:true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        }
      }: {
        slidesPerView: "auto",
        autoplay: false
      };
      return tmp
    },
    items() {
      return data;
    }
  },
  data() {
    return {
      showNext: 0,
      progress:'',
      showPre: 0,
      isMobile: browser.mobile,
      activeIdx: this.active
    };
  },
  methods: {
    slide(name){
      this.swiper[name]()
      this.progress =this.swiper.progress
    },
    goto(item) {
      this.activeIdx = item.link
      this.$emit('handleItem',item)
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  watch:{
    active(newVal){
      this.activeIdx = newVal
    },
    activeIdx(newVal){
      let idx = this.items.findIndex(i=>i.link===newVal)
      this.swiper.slideTo(idx)
      this.progress = this.swiper.progress
    }
  },
  props:['active'],
  mounted() {
    let idx = this.items.findIndex(i=>i.link===this.active)
    this.swiper.slideTo(idx)
    this.progress = this.swiper.progress
  },
};
</script>
<style lang="less" scoped>
@cdn:'https://houseoss.4dkankan.com/chenfang';
@margin:40px;
.swiper-contain {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  background: url("@{cdn}/assets/images/bg_bottom.png") no-repeat;
  background-position: bottom left;
  background-size: 100%;
  >img{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    max-width: 45px;
  }
  .v-l{
    left: @margin;
  }
  .v-r{
    right: @margin;
  }
  .swiper-wrapper {
    width: 80%;
    margin: 0 auto;
    .swiper-slide {
      transform-style: preserve-3d;
      height: auto!important;
      width: 150px;
      padding: 10px;
      cursor: pointer;
      .sw-card{
        text-align: center;
        margin-bottom: 6px;
        img {
          overflow: hidden;
          width: 100%;
          margin-top: 10px;
          border-radius: 12px;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.4);
        }
        p{
          color: #fff;
          text-align: center;
          margin: 0 10px;
          font-size: 18px;
        }
      }
      .swActive{
        img{
          box-shadow: 2px 0 20px #F7BB0F;
        }
      }
    }
  }
}

@media screen and (max-width: 500px) {
  .swiper-contain {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    .swiper-wrapper {
      width: 100%;
      .swiper-slide {
        transform-style: preserve-3d;
        height: auto!important;
        width: 50%;
        padding: 5px;
        cursor: pointer;
        .sw-card{
          text-align: center;
          margin-bottom: 6px;
          img {
            overflow: hidden;
            width: calc(100% - 16px);
            margin-top: 10px;
          }
          p{
            color: #fff;
            text-align: center;
            margin: 0 10px;
          }
        }
      }
    }
  }
}
</style>
